'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
require('./svg-icon-501cae97.js');
var accessTime = require('./access-time-9bf228a6.js');
var field = require('./field-e92a9467.js');
var moment = _interopDefault(require('moment'));
var parseTime_util = require('./parse-time.util-fac3de5c.js');

var TIME_FORMAT_12_HOURS = 'hh:mm a';
var TIME_PLACEHOLDER_12_HOURS = '--:-- --';
var TIME_FORMAT_24_HOURS = 'HH:mm';
var TIME_PLACEHOLDER_24_HOURS = '--:--';

var useFormattedTime = function (_a) {
    var value = _a.value, is12h = _a.is12h;
    return React.useMemo(function () {
        if (!value)
            return null;
        var tmpDate = moment();
        var _a = tslib_es6.__read(parseTime_util.parseTime(value), 2), hours = _a[0], minutes = _a[1];
        tmpDate.hours(hours);
        tmpDate.minutes(minutes);
        return tmpDate.format(is12h ? TIME_FORMAT_12_HOURS : TIME_FORMAT_24_HOURS);
    }, [value, is12h]);
};

var useTimePlaceholder = function (_a) {
    var is12h = _a.is12h, placeholder = _a.placeholder;
    return React.useMemo(function () {
        if (placeholder)
            return placeholder;
        return is12h ? TIME_PLACEHOLDER_12_HOURS : TIME_PLACEHOLDER_24_HOURS;
    }, [is12h, placeholder]);
};

var TimeField = function (_a) {
    var value = _a.value, is12h = _a.is12h, _b = _a.Icon, Icon = _b === void 0 ? accessTime.AccessTime : _b, placeholder = _a.placeholder, variant = _a.variant, fieldProps = tslib_es6.__rest(_a, ["value", "is12h", "Icon", "placeholder", "variant"]);
    var timeFormatted = useFormattedTime({ value: value, is12h: is12h });
    var timePlaceholder = useTimePlaceholder({ placeholder: placeholder, is12h: is12h });
    return (React__default.createElement(field.Field, tslib_es6.__assign({ value: timeFormatted, Icon: Icon, placeholder: timePlaceholder, variant: variant }, fieldProps, { "data-testid": "time-field", "data-cy": "time-field" })));
};

exports.TimeField = TimeField;
